// modifer: styles/jss/nextjs-material-kit-pro/pages/profilePageStyle
import { title } from 'styles/jss/original/base';

const styles = {
  title: {
    ...title,
    marginBottom: '0'
  }
};

export default styles;
